import React from 'react'
import { Badge, Table, Td, Th, Tr } from '@/shared/ui'
import { listRevshareBankAccountsOf, type RevshareBankAccount } from '../services/revshareBankService'

export default function RevshareParticipantBankAccountsPanel({ userId }: { userId: string }) {
  const [rows, setRows] = React.useState<RevshareBankAccount[]>([])
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    ;(async () => {
      setLoading(true)
      setError(null)
      try {
        setRows(await listRevshareBankAccountsOf(userId))
      } catch (e: any) {
        setError(e?.message || 'Falha ao carregar dados bancarios')
        setRows([])
      } finally {
        setLoading(false)
      }
    })()
  }, [userId])

  return (
    <div className="mt-8">
      <div className="mb-3 text-base font-medium">Dados bancarios</div>
      {error && (
        <div className="mb-3 rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">
          {error}
        </div>
      )}
      {loading ? (
        <div className="text-sm text-foreground/70">Carregando...</div>
      ) : (
        <Table>
          <thead>
            <Tr>
              <Th>Metodo</Th>
              <Th>Titular</Th>
              <Th>Documento</Th>
              <Th>Chave/Conta</Th>
              <Th>Padrao</Th>
            </Tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <Tr key={r.id}>
                <Td>{(r.method || '').toUpperCase()}</Td>
                <Td>{r.holder_name}</Td>
                <Td>{r.document || '-'}</Td>
                <Td>
                  {r.method === 'pix'
                    ? r.pix_key_value || '-'
                    : `${r.bank_code || ''} ${r.branch || ''} ${r.account_number || ''}`.trim() || '-'}
                </Td>
                <Td>
                  {r.is_default ? (
                    <Badge variant="soft" color="success">
                      Padrao
                    </Badge>
                  ) : (
                    <span className="text-foreground/70">-</span>
                  )}
                </Td>
              </Tr>
            ))}
            {rows.length === 0 && (
              <Tr>
                <Td colSpan={5} className="py-6 text-center text-sm text-foreground/70">
                  Sem dados bancarios.
                </Td>
              </Tr>
            )}
          </tbody>
        </Table>
      )}
    </div>
  )
}

